"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.61 5.41 1.4 8l2.21 2.59-.76.65L.09 8l2.76-3.24.76.65Zm9.53-.65-.76.65L14.59 8l-2.21 2.59.76.65L15.9 8l-2.76-3.24Zm-8.15 7.4.87.5L11 3.83l-.87-.5-5.14 8.84v-.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.145 7.92 1.665 12l3.48 4.08-.855.728-4.11-4.815 4.11-4.815.855.727v.015Zm14.565-.727-.855.727 3.48 4.08-3.48 4.08.855.728 4.11-4.815-4.11-4.815v.015ZM7.582 18.473l.975.562 7.86-13.507-.975-.563-7.86 13.508Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.86 10.56 2.22 16l4.64 5.44-1.14.97-5.48-6.42 5.48-6.42 1.14.97v.02Zm19.42-.97-1.14.97L29.78 16l-4.64 5.44 1.14.97 5.48-6.42-5.48-6.42v.02ZM10.11 24.63l1.3.75L21.89 7.37l-1.3-.75-10.48 18.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.832 15.518 2.595 24l7.237 8.483-1.425 1.215L.135 24l8.272-9.697 1.425 1.215ZM39.6 14.303l-1.425 1.215L45.412 24l-7.237 8.483 1.425 1.215L47.872 24 39.6 14.303ZM15.157 37.335l1.62.945 16.065-27.6-1.62-.945-16.065 27.6Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.11 20.69 3.46 32l9.65 11.31-1.9 1.62L.18 32l11.03-12.93 1.9 1.62Zm39.69-1.62-1.9 1.62L60.55 32 50.9 43.31l1.9 1.62L63.83 32 52.8 19.07ZM20.21 49.78l2.16 1.26 21.42-36.8-2.16-1.26-21.42 36.8Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCode = function IconCode(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Code' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Code"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCode.sizes = [16, 24, 32, 48, 64];
IconCode.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCode;
exports.default = _default;